export default {
  // 模块名称
  log: {
    // 按钮类
    button: {
      query: '查询',
      reset: '重置',
      export: '导出',
      close: '关闭',
      detail: '查看'
    },
    // 文字标签类
    label: {
      no: '序号',
      module: '操作模块',
      function: '操作功能',
      type: '操作类型',
      account: '操作账号',
      name: '姓名',
      timeRange: '起止时间',
      operatTime: '操作时间',
      operatResult: '操作结果',
      ip: '操作IP',
      desc: '操作内容',
      operations: '操作',
      to: '至'
    },
    // 提示类
    placeholder: {
      select: '请选择',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: '日志详情',
      exportName: '日志记录'
    }
  }
}